var map = {
	"./air-nga-en/assets/profile-nav-icon-active.png": 35642,
	"./ais-tai-en/assets/profile-nav-icon-active.png": 53063,
	"./ais-tai-tha/assets/profile-nav-icon-active.png": 25971,
	"./demo-arabic/assets/profile-nav-icon-active.png": 38155,
	"./demo-et-en/assets/profile-nav-icon-active.png": 21262,
	"./demo-romanian/assets/profile-nav-icon-active.png": 67636,
	"./demo-um-en/assets/profile-nav-icon-active.png": 63787,
	"./dtac-tai-en/assets/profile-nav-icon-active.png": 94292,
	"./dtac-tai-tha/assets/profile-nav-icon-active.png": 98994,
	"./ethiotel-et-amh/assets/profile-nav-icon-active.png": 88832,
	"./ethiotel-et-en/assets/profile-nav-icon-active.png": 66393,
	"./mtn-cg-fr/assets/profile-nav-icon-active.png": 98184,
	"./mtn-ci-fr/assets/profile-nav-icon-active.png": 88098,
	"./mtn-cmr-fr/assets/profile-nav-icon-active.png": 7990,
	"./mtn-gha-en/assets/profile-nav-icon-active.png": 43905,
	"./mtn-nga-en/assets/profile-nav-icon-active.png": 21413,
	"./mtn-zam-en/assets/profile-nav-icon-active.png": 92811,
	"./saf-ke-en/assets/profile-nav-icon-active.png": 4422,
	"./saudi-uae-en/assets/profile-nav-icon-active.png": 9627,
	"./tlk-za-en/assets/profile-nav-icon-active.png": 9325,
	"./vc-za-en/assets/profile-nav-icon-active.png": 48118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80546;